var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Const } from './const.mod';
// price feed provider
import { PriceFeedProvider, PriceFeedProviderMixins, PriceFeedProviderStore } from './provider/ws-price-feed/price-feed-provider.lib';
// trader transactions provider
// import { TraderTransactionsProvider, TraderTransactionsProviderConst, 
//   TraderTransactionsProviderMixins, TraderTransactionsProviderStore } 
//     from './provider/poll-trader-transactions/trader-transactions-provider.lib'
// main store module contributions  
import { actions } from './store/actions';
import { state } from './store/state';
import { mutations } from './store/mutations';
import { getters } from './store/getters';
// create main store module and merge provider store contributions
var vueProviderStore = {
    state: __assign(__assign({}, state), PriceFeedProviderStore.state // price feed store state
    ),
    actions: __assign(__assign({}, actions), PriceFeedProviderStore.actions),
    mutations: __assign(__assign({}, mutations), PriceFeedProviderStore.mutations),
    getters: __assign(__assign({}, getters), PriceFeedProviderStore.getters)
};
/**
 * init all providers injectinf vuex store instance
 */
var initProviders = function (store) {
    return [
        new PriceFeedProvider(store),
    ];
};
/**
 *  component mixins
 */
export var ProviderCacheMixins = {
    created: function () {
        // dynamically extend store with price feed store module
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[Const.STORE_MODULE_NAME])) {
            this.$store.registerModule(Const.STORE_MODULE_NAME, vueProviderStore);
        }
    },
    computed: __assign({}, PriceFeedProviderMixins.computed),
    mounted: function () {
        var _this = this;
        window.onunload = function () {
            console.log('window on unloading >>>');
            var providers = _this.$store.getters[Const.GET_PROVIDERS];
            for (var p in providers) {
                providers[p].stop();
                delete providers[p];
            }
        };
        // emote request to data ware house 
        // therefor why we go over the facade
        this.$store.dispatch(Const.RUN_REGISTER_PROVIDERS, initProviders(this.$store));
    },
    beforeDestroy: function () {
        console.log('component before destroy >>>');
        var providers = this.$store.getters[Const.GET_PROVIDERS];
        for (var p in providers) {
            providers[p].stop();
            delete providers[p];
        }
    },
    methods: __assign({}, PriceFeedProviderMixins.methods)
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/mixin.ts
// module id = null
// module chunks = 